import { render, staticRenderFns } from "./PriceLevelingItemEdit.vue?vue&type=template&id=fdf91da2&scoped=true&"
import script from "./PriceLevelingItemEdit.vue?vue&type=script&lang=js&"
export * from "./PriceLevelingItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./PriceLevelingItemEdit.vue?vue&type=style&index=0&id=fdf91da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf91da2",
  null
  
)

export default component.exports